import { Box, Skeleton } from '@mui/material'

let SessionCardSkeleton = () => (
  <Box
    sx={{
      width: '100%',
      aspectRatio: '16/9',
      borderRadius: 2,
      overflow: 'hidden',
    }}
  >
    <Skeleton variant="rectangular" width="100%" height="100%" />
  </Box>
)

let DayColumnSkeleton = () => (
  <Box>
    {/* Day Header Skeleton */}
    <Box sx={{ textAlign: 'center', mb: 2 }}>
      <Skeleton
        variant="text"
        width={60}
        height={16}
        sx={{ mx: 'auto', mb: 0.5 }}
      />
      <Skeleton variant="text" width={40} height={48} sx={{ mx: 'auto' }} />
    </Box>

    {/* Sessions Skeleton */}
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <SessionCardSkeleton />
      <SessionCardSkeleton />
    </Box>
  </Box>
)

export let ScheduleSkeleton = () => (
  <Box className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
    {Array.from({ length: 5 }).map((_, index) => (
      <DayColumnSkeleton key={index} />
    ))}
  </Box>
)
